import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { FuseSharedModule } from '@fuse/shared.module';

import { EvaluacionComponent } from './evaluacion.component';
import { EvaluacionListadoPrintComponent } from './evaluacion-listado-print.component';
import { EvaluacionControlesSugeridosPrintComponent} from './evaluacion-controles-sugeridos-print.component';
import { EvaluacionMedidasDeContingenciaPrintComponent} from './evaluacion-medidas-de-contingencia-print.component';
import { EvaluacionKrisPrintComponent} from './evaluacion-kris-print.component';
import { EvaluacionControlesCriticosPrintComponent} from './evaluacion-controles-criticos-print.component';


import { PreiniciarEvaluacionComponent } from './preiniciar-evaluacion.component';

import { EvaluacionViewComponent } from './evaluacion-view.component';
import { MisEvaluacionesComponent } from './mis-evaluaciones.component';

import { ConsolidacionComponent } from './consolidacion.component';
import { ConsolidacionViewComponent } from './consolidacion-view.component';
import { MisConsolidacionesComponent } from './mis-consolidaciones.component';

import {MatTooltipModule} from '@angular/material/tooltip';

import { ConsolidarEvaluacionComponent } from './consolidar-evaluacion.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { DialogBoxComponent } from './dialog/dialog-box.component';
import { ConsolidacionDialogBoxComponent } from './dialog/consolidacion-dialog-box.component';
import { DialogBoxCambioEstadoComponent } from './dialog/dialog-box-cambio-estado.component';
import { DialogBoxPrintComponentEvaluacionDetallada } from './dialog/dialog-print-box.component';
import { DialogBoxPrintComponentEvaluacionMedidasDeContingencia } from './dialog/dialog-medidas-de-contingencia-print-box.component';

import { DialogBoxPrintComponentEvaluacionConsolidadaDetallada } from './dialog/dialog-consolidacion-print-box.component';
import { KriModule } from '../kri/kri.module';
import { DialogBoxCopiarComponent } from './dialog/dialog-box-copiar.component';
import {MatChipsModule} from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule ,MAT_DATE_LOCALE} from '@angular/material/core';
import {MatTabsModule} from '@angular/material/tabs';
import {MatCardModule} from '@angular/material/card';
import {MatIconModule} from '@angular/material/icon';
import {MatStepperModule} from '@angular/material/stepper';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { RouterModule } from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatPaginatorModule } from '@angular/material/paginator';


import { AddMedidaDeContingenciaDialogBoxComponent} from './dialog/add-medidas-de-contingencia-dialog-box.component';
import { FiltrosComponent } from './dialog/filtros.component';

import { EvaluacionesListComponent} from './cards/evaluaciones-list.component';


@NgModule({
    declarations: [
        EvaluacionComponent,
        EvaluacionListadoPrintComponent,
        EvaluacionControlesSugeridosPrintComponent,
        EvaluacionMedidasDeContingenciaPrintComponent,
        EvaluacionControlesCriticosPrintComponent,
        EvaluacionKrisPrintComponent,
        PreiniciarEvaluacionComponent,
        EvaluacionViewComponent,
        MisEvaluacionesComponent,
        DialogBoxComponent,
        AddMedidaDeContingenciaDialogBoxComponent,
        DialogBoxCambioEstadoComponent,
        DialogBoxCopiarComponent,
        ConsolidarEvaluacionComponent,
        ConsolidacionComponent,
        MisConsolidacionesComponent,
        ConsolidacionViewComponent,
        ConsolidacionDialogBoxComponent,
        DialogBoxPrintComponentEvaluacionDetallada,
        DialogBoxPrintComponentEvaluacionMedidasDeContingencia,
        DialogBoxPrintComponentEvaluacionConsolidadaDetallada,
        FiltrosComponent,
        EvaluacionesListComponent
    ],
    imports     : [
        BrowserAnimationsModule,
        FormsModule,
        MatTableModule,
        MatDialogModule,
        MatTooltipModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatInputModule,
        MatSelectModule,
        MatChipsModule,
        FuseSharedModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatTabsModule,
        MatCardModule,
        MatIconModule,
        MatStepperModule,
        MatSnackBarModule,
        TranslateModule,
        NgxChartsModule,
        KriModule,
        RouterModule,
        MatSidenavModule,
        MatPaginatorModule
    ],
    providers: [
      MatDatepickerModule,
      MatNativeDateModule,
      { provide: MAT_DATE_LOCALE, useValue: 'es-ES' }
    ],
    entryComponents: [
        DialogBoxComponent,
        AddMedidaDeContingenciaDialogBoxComponent,
        DialogBoxCambioEstadoComponent,
        DialogBoxCopiarComponent,
        ConsolidacionDialogBoxComponent,
        DialogBoxPrintComponentEvaluacionDetallada,
        DialogBoxPrintComponentEvaluacionMedidasDeContingencia,
        DialogBoxPrintComponentEvaluacionConsolidadaDetallada,
        FiltrosComponent,
        EvaluacionesListComponent
    ],
    exports: [FiltrosComponent]
})
export class EvaluacionModule
{
}
